export const defaultChoiceIndex = (choice, choicesLength) => {
  const count = Math.abs(choice)

  if (choicesLength === 2) return count ? (count > 1 ? 1 : 0) : 1

  return count ? Math.min(count, 2) : 0
}

const fewOrMany = isFew => (choice, choicesLength) => {
  const count = Math.abs(choice)

  if (choicesLength !== 4 || count < 2) {
    return defaultChoiceIndex(choice, choicesLength)
  }

  return isFew(count) ? 2 : 3
}

export const pluralizationRules = {
  pl: fewOrMany(
    count =>
      count % 10 >= 2 &&
      count % 10 <= 4 &&
      (count % 100 < 12 || count % 100 > 14)
  ),
  cs: fewOrMany(count => count <= 4),
  ro: fewOrMany(count => count % 100 >= 1 && count % 100 <= 19),
}

export const choiceIndex = (locale, choice, choicesLength) =>
  (pluralizationRules[locale] || defaultChoiceIndex)(choice, choicesLength)
